import { GridRowId, GridValidRowModel } from '@mui/x-data-grid-premium';
import { createContext, ReactNode, useContext, useState } from 'react';

type BulkEditDataGridContextType = {
  selectedRowIds: string[];
  setSelectedRowIds: (e: string[]) => void;
  firstSelectedGridRowData: { key: GridRowId; value: GridValidRowModel };
  setFirstSelectedGridRowData: (e: {
    key: GridRowId;
    value: GridValidRowModel;
  }) => void;
};

export const BulkEditDataGridContext = createContext<
  Partial<BulkEditDataGridContextType>
>({});

export const useBulkEditDataGridContext = () =>
  useContext(BulkEditDataGridContext);

export type BulkEditDataGridProviderProps = {
  children: ReactNode;
};

const BulkEditDataGridProvider = ({
  children,
}: BulkEditDataGridProviderProps) => {
  const [selectedRowIds, setSelectedRowIds] = useState<string[]>([]);
  const [firstSelectedGridRowData, setFirstSelectedGridRowData] = useState<{
    key: GridRowId;
    value: GridValidRowModel;
  }>();

  return (
    <BulkEditDataGridContext.Provider
      value={{
        selectedRowIds,
        setSelectedRowIds,
        firstSelectedGridRowData,
        setFirstSelectedGridRowData,
      }}
    >
      {children}
    </BulkEditDataGridContext.Provider>
  );
};

export default BulkEditDataGridProvider;
